module.exports = __webpack_public_path__ + "img/description-frame.343e1e11.png";